import { createFileRoute } from '@tanstack/react-router';

import Settings from '@/ui/pages/Settings/Settings';

export const Route = createFileRoute('/_dashboard/settings')({
  component: Settings,
});
